
import { SWRConfiguration, SWRResponse } from "swr";

import { IReturn, QueryParticipantSourceDataAllocations, QueryParticipantSourceDataAllocationsResponse, Participant, ParticipantSourceDataAllocation } from "@/api/dtos";
import { useMemo } from "react";
import useCachedDataQuery from '@/hooks/api/useCachedDataQuery';
import { AppSettings } from "@/AppSettings";
import useParticipantSourceDataAllocations from "./useParticipantSourceDataAllocations";


export const useParticipantSourceDataAllocation = (query?: Partial<ParticipantSourceDataAllocation>, configuration?: SWRConfiguration | undefined) => {
    const response = useParticipantSourceDataAllocations(query, configuration);

    return useMemo(() => {
        return {
            data: response.data?.find(x => true), 
            error: response.error, 
            loading: response.loading, 
            validating: response.validating, 
            refresh: response.refresh, 
            mutate: response.mutate
        }

    }, [response.data, response.error, response.loading, response.validating, response.refresh, response.mutate]);
}

export default useParticipantSourceDataAllocation;